import { useState, useRef, useEffect } from 'react';
import { AI_REPLIES } from '../data/data';

const INIT = [
  { role: 'ai', text: "👋 Hi! I'm your Think & See AI. Ask me for personalised recommendations!" },
  { role: 'ai', text: 'Try: "Suggest a thriller" or "Something like Dune?" or "Best book for tonight?"' },
];

export default function AIChatWidget() {
  const [open, setOpen] = useState(false);
  const [msgs, setMsgs] = useState(INIT);
  const [input, setInput] = useState('');
  const [typing, setTyping] = useState(false);
  const bodyRef = useRef(null);

  useEffect(() => {
    if (bodyRef.current) bodyRef.current.scrollTop = bodyRef.current.scrollHeight;
  }, [msgs, typing]);

  const send = () => {
    if (!input.trim()) return;
    setMsgs(p => [...p, { role: 'user', text: input }]);
    setInput('');
    setTyping(true);
    setTimeout(() => {
      setTyping(false);
      setMsgs(p => [...p, { role: 'ai', text: AI_REPLIES[Math.floor(Math.random() * AI_REPLIES.length)] }]);
    }, 1100);
  };

  return (
    <>
      {/* FAB */}
      <button
        onClick={() => setOpen(o => !o)}
        style={{
          position: 'fixed', bottom: '2rem', right: '2rem', zIndex: 800,
          width: 56, height: 56, borderRadius: '50%', border: 'none',
          background: 'linear-gradient(135deg,var(--teal),var(--violet))',
          fontSize: '1.4rem', display: 'flex', alignItems: 'center', justifyContent: 'center',
          boxShadow: '0 8px 32px rgba(0,212,180,.42)', animation: 'fabPulse 3s ease infinite',
          cursor: 'pointer', transition: 'transform 0.25s',
        }}
        onMouseEnter={e => e.currentTarget.style.transform = 'scale(1.1)'}
        onMouseLeave={e => e.currentTarget.style.transform = 'scale(1)'}
      >{open ? '✕' : '🤖'}</button>

      {/* Window */}
      {open && (
        <div style={{
          position: 'fixed', bottom: '5.5rem', right: '2rem', zIndex: 800, width: 340,
          background: 'var(--surface)', border: '1px solid var(--border2)', borderRadius: 20,
          boxShadow: '0 32px 80px rgba(0,0,0,.65)', overflow: 'hidden', animation: 'chatIn 0.28s ease',
        }}>
          {/* Head */}
          <div style={{ background: 'linear-gradient(135deg,rgba(0,212,180,.15),rgba(124,107,255,.1))', borderBottom: '1px solid var(--border)', padding: '1rem 1.1rem', display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
            <div style={{ width: 36, height: 36, borderRadius: '50%', background: 'linear-gradient(135deg,var(--teal),var(--violet))', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1.1rem' }}>🤖</div>
            <div>
              <div style={{ fontWeight: 800, fontSize: '0.88rem' }}>Think &amp; See AI</div>
              <div style={{ fontFamily: 'var(--font-mono)', fontSize: '0.59rem', color: 'var(--teal)', marginTop: 2 }}>● Online · Instant replies</div>
            </div>
            <button onClick={() => setOpen(false)} style={{ marginLeft: 'auto', background: 'transparent', border: 'none', color: 'var(--muted)', cursor: 'pointer', fontSize: '1rem' }}>✕</button>
          </div>

          {/* Messages */}
          <div ref={bodyRef} style={{ height: 260, overflowY: 'auto', padding: '1rem', display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
            {msgs.map((m, i) => (
              <div key={i} style={{
                maxWidth: '86%', padding: '0.65rem 0.9rem', borderRadius: 14,
                fontSize: '0.82rem', lineHeight: 1.55, animation: 'msgIn 0.25s ease',
                alignSelf: m.role === 'ai' ? 'flex-start' : 'flex-end',
                background: m.role === 'ai' ? 'var(--surface2)' : 'linear-gradient(135deg,var(--teal),#00a89a)',
                border: m.role === 'ai' ? '1px solid var(--border)' : 'none',
                color: m.role === 'ai' ? 'var(--text2)' : '#040508',
                fontWeight: m.role === 'ai' ? 400 : 600,
                borderBottomLeftRadius: m.role === 'ai' ? 4 : 14,
                borderBottomRightRadius: m.role === 'ai' ? 14 : 4,
              }}>{m.text}</div>
            ))}
            {typing && (
              <div style={{ alignSelf: 'flex-start', background: 'var(--surface2)', border: '1px solid var(--border)', borderRadius: 14, borderBottomLeftRadius: 4, padding: '0.65rem 0.9rem', display: 'flex', gap: 4 }}>
                {[0, 200, 400].map(d => (
                  <span key={d} style={{ width: 6, height: 6, borderRadius: '50%', background: 'var(--muted)', display: 'inline-block', animation: `pulse 1.4s ease infinite ${d}ms` }} />
                ))}
              </div>
            )}
          </div>

          {/* Input */}
          <div style={{ borderTop: '1px solid var(--border)', padding: '0.75rem 1rem', display: 'flex', gap: '0.5rem' }}>
            <input
              value={input}
              onChange={e => setInput(e.target.value)}
              onKeyDown={e => e.key === 'Enter' && send()}
              placeholder="Ask for a recommendation…"
              style={{ flex: 1, background: 'var(--surface2)', border: '1px solid var(--border)', borderRadius: 8, padding: '0.5rem 0.8rem', fontFamily: 'var(--font-body)', fontSize: '0.82rem', color: 'var(--text)', outline: 'none' }}
            />
            <button onClick={send} style={{ background: 'linear-gradient(135deg,var(--teal),#00a89a)', color: '#040508', border: 'none', width: 34, height: 34, borderRadius: 8, fontSize: '0.9rem', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, fontWeight: 800 }}>→</button>
          </div>
        </div>
      )}
    </>
  );
}
